import { mapGetters } from 'vuex';
import axiosvl from "../axios/axios-vl.js";

export default {
    data() {
        return {
            customerlocationlist: [],
            backorderallowed: false
        }
    },
    methods: {
        addToCartValidation (product) {
            let returndata = {
                status: 'ER',
                message: ''
            }

            if (product.quantity === 0) {
                returndata.status = 'ER';
                returndata.message = 'Please specifiy a quantity to add item ' + product.item + ' to your cart.';  
                return returndata;
            }

            // If backorder is not allowed, check that the new quantity does not exceed the stock quantity 
            if (!this.backorderallowed) {
                // let productInCartIndex = this.cart.findIndex( (ci) => ci.ID === product.ID );
                let productInCartIndex = this.cart.findIndex( 
                    (ci) => 
                        ci.item === product.item &&
                        ci.manufacturer === product.manufacturer &&
                        ci.locationid === product.locationid
                );


                // console.log('index - ' + productInCartIndex);

                if (productInCartIndex >= 0) {
                    // Updating the cart
                    // const newqty = parseInt(this.cart[productInCartIndex].quantity) + parseInt(product.quantity);
                    let productstock = this.cart[productInCartIndex].stockquantity === undefined ? this.cart[productInCartIndex].stockquantity : product.stockquantity;

                    returndata.status = 'OK'
                    returndata.message = '.'

                    if (productstock === 0) {
                        returndata.status = 'ER';
                        returndata.message = 'Item ' + product.item + ' is out of stock.';    
                    } else {
                        // remove these validation because we are allowing to purchase more than stock quantity
                        // issue #260
                        // https://gitlab.com/lansa/dms_ecommerce/-/issues/260#note_686460047
                        // if (newqty > productstock) {
                        //     returndata.status = 'ER';
                        //     returndata.message = 'Requested quantity for Item ' + product.item + ' exceeds stock quantity of ' + this.cart[productInCartIndex].stockquantity;
                        // }
                    }

                } else {
                    // Adding to the cart

                    // console.log('add to cart - ' + product.quantity + ' - ' + product.stockquantity);
                    returndata.status = 'OK'
                    returndata.message = '.'

                    if (product.stockquantity === 0) {
                        returndata.status = 'ER';
                        returndata.message = 'Item ' + product.item + ' is out of stock.';    
                    } else {

                        // remove these validation because we are allowing to purchase more than stock quantity
                        // issue #260
                        // https://gitlab.com/lansa/dms_ecommerce/-/issues/260#note_686460047
                        // if (product.quantity > product.stockquantity) {
                        //     returndata.status = 'ER';
                        //     returndata.message = 'Requested quantity for Item ' + product.item + ' exceeds stock quantity of SSS ' + product.stockquantity;
                        // } 
                    }

                }

            } else {
                returndata.status = 'OK'
                returndata.message = ''
            }
            // console.log('cart.js - ' + JSON.stringify(returndata));
            return returndata;
        },
        async mx_getLocationDetails() {
            // Use this to get a list of locations and the location sequence
            this.customerlocationlist = [];

            return await axiosvl.post(this.$store.getters['api/customer_locations_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;

                if (fields.RESULTCOD.value === 'OK') {
                    for (const key in response.data.webroutine.lists.LOCS.entries) {
                        const obj = response.data.webroutine.lists.LOCS.entries[key];

                        this.customerlocationlist.push({
                            "locationid": obj.LCLOC,
                            "locationname": obj.LCNAME,
                            "locationtaxcity": obj.LCTAXC,
                            "locationsequence": obj.O9SQLO,
                            "locationcity": obj.ADCITY,
                            "locationstate": obj.ADSTTC
                        });
                    }
                    
                } 

                return this.customerlocationlist;
            })
            .catch((error) => {
                console.log("error - " + error);
                return this.customerlocationlist;
            });
        },
        initializeData() {
            let storefrontBOsetting = this.storefrontAttributes.find(attribute => attribute.type === 'BKO').value;
            let customerBOsetting = this.$store.getters.getCustomerDetails.allowbackorder;
            // comment out hardcoded
            // customerBOsetting = 'Y';
            this.backorderallowed = storefrontBOsetting === 'Y' && customerBOsetting === 'Y';
        }

    },
    computed: {
        ...mapGetters([
            'storefrontAttributes'
        ]),
        ...mapGetters("cart", [
            "cart",
            "totals"
        ])
    },
    watch: {
        storefrontAttributes() {
            this.initializeData();
        }
    },
    created() {
        this.initializeData();
    }
};